/**
 * Sets a country's recipient timezone (PUT plans/:countryKey/timezone). The
 * zone lives on the country catalog, shared with Automations; every Drop
 * Generator read (plan, day plan, hour profile) refreshes after it.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/services/api';

import { dropGeneratorKeys } from '../useDropGenerator';

export function usePlanTimezone() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: { countryKey: string; recipientTimezone: string }) => {
      const res = await api.put<{ data: { countryKey: string; recipientTimezone: string } }>(
        `/drop-generator/plans/${input.countryKey}/timezone`,
        { recipientTimezone: input.recipientTimezone },
      );
      return res.data.data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: dropGeneratorKeys.all }),
  });
}
